import React from 'react';
import Card from '../Card';
import UserPlayer from '../../entities/players/UserPlayer';
import Constants from '../../constants/Constants';

export default class SurpriseMealCard extends Card {

    onAfterCardThrownFromPlayerToUsedPile = async () => {
        this.gameCtx.soundRepository.playSoundByName(Constants.SOUND_SURPRISE_MEAL_CARD);

        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();

        cEntity.setFinalUserEvent();

        if (cEntity instanceof UserPlayer) {
            await this.gameCtx.waitFor(Constants.INTERVAL_CARD_MOVE_FULL);
            await this.userPlayerSurpriseMealCardMove();
        }
        else {
            await this.gameCtx.waitFor(Constants.INTERVAL_CARD_MOVE_FULL);
            await this.computerPlayerSurpriseMealCardMove();
        }
    }

    // COMPUTER PLAYER MOVE

    computerPlayerSurpriseMealCardMove = async (card) => {
        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();

        await this.gameCtx.moveCard(cEntity.entityIndex, Constants.USED_PILE_INDEX, card, true, true);
        await cEntity.getCardsFromNewPile(2);

        cEntity.chooseRandCard();

        await this.gameCtx.moveCard(cEntity.entityIndex, Constants.USED_PILE_INDEX, cEntity.chosenCard, true, true);

        cEntity.chooseRandCard();

        await this.gameCtx.moveCard(cEntity.entityIndex, Constants.USED_PILE_INDEX, cEntity.chosenCard, true, true);
    }

    // USER PLAYER MOVE

    userPlayerSurpriseMealCardMove = async (card) => {
        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();
        if (cEntity.isTimeForActionCardsEventsUp()) {
            let text = <div className="popup-text interval-popup-text increasd-text">קלף "ארוחה בהפתעה" נכנס לפעולה!</div>;
            cEntity.addPopupWithInterval(text);
            await this.gameCtx.waitFor(Constants.INTERVAL_BEFORE_REMOVE_POPUP);
            this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_CARD_POPUP);

            // if (cEntity.isTimeForActionCardsEventsUp()) {
                await this.gameCtx.moveCard(cEntity.entityIndex, Constants.USED_PILE_INDEX, card, true, true);
                await cEntity.getCardsFromNewPile(2);

                cEntity.addBubbleOnBottomPlayer("זרוק 2 קלפים", Constants.ELEMENT_MY_PLAYER_THROW_A_CARD);
                cEntity.subscribeUserEventToCards((cardObj) => cEntity.handleChooseCardEvent(cardObj), Constants.FLAGS_MULTIPLE_TIME_USE);
                await cEntity.waitForEvent();
                await this.gameCtx.moveCard(cEntity.entityIndex, Constants.USED_PILE_INDEX, cEntity.chosenCard, true, true);

                cEntity.subscribeUserEventToCards((cardObj) => cEntity.handleChooseCardEvent(cardObj), Constants.FLAGS_MULTIPLE_TIME_USE);
                await cEntity.waitForEvent();
                await this.gameCtx.moveCard(cEntity.entityIndex, Constants.USED_PILE_INDEX, cEntity.chosenCard, true, true);

                this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_MY_PLAYER_THROW_A_CARD);
            // } else {
            //     cEntity.informTimesUp();
            // }

        }
        else {
            cEntity.informTimesUp();
        }
        
        cEntity.resolvePlayerFinal();
    }
}